import { render, staticRenderFns } from "./sucess.vue?vue&type=template&id=3fc6da1c&scoped=true"
import script from "./sucess.vue?vue&type=script&lang=js"
export * from "./sucess.vue?vue&type=script&lang=js"
import style0 from "./sucess.vue?vue&type=style&index=0&id=3fc6da1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6da1c",
  null
  
)

export default component.exports